(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jacu-fabric-links"] && !Shopify.designMode) return;
  try {
    (() => {
  let mapping;
  const escapePattern = value => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  async function enhance(root = document) {
    const cards = root.querySelectorAll('[data-jacu-fabric-invitation]:not([data-card-enhanced])');
    if (!cards.length) return;
    try {
      mapping ||= fetch(cards[0].dataset.mapUrl).then(response => {
        if (!response.ok) throw new Error('Fabric map unavailable');
        return response.json();
      }).catch(error => { mapping = undefined; throw error; });
      const map = await mapping;
      const aliases = map.flatMap(item => item.aliases.map(alias => ({ alias, item }))).sort((a, b) => b.alias.length - a.alias.length);
      const pattern = new RegExp('\\b(?:' + aliases.map(({ alias }) => escapePattern(alias)).join('|') + ')\\b', 'gi');
      cards.forEach(card => {
        if (card.dataset.cardEnhanced) return;
        const details = card.closest('.jp-details') || card.parentElement;
        const description = details.querySelector('.rte, .product__description');
        if (!description) return;
        const composition = [...description.querySelectorAll('li, p, tr')].filter(element => /(?:composition|materials?|fabric)\s*:/i.test(element.textContent) || /\d+(?:[.,]\d+)?\s*%/.test(element.textContent)).map(element => element.textContent).join(' ');
        const matches = [...composition.matchAll(pattern)].map(match => aliases.find(entry => entry.alias.toLowerCase() === match[0].toLowerCase()).item);
        const fabric = matches[0];
        if (fabric) {
          card.href = card.dataset.destination + '#' + fabric.anchor;
          card.querySelector('[data-fabric-cta]').textContent = 'Discover ' + fabric.label.toLowerCase();
        }
        const note = document.querySelector('[data-jacu-garment-feel]');
        if (note && !document.querySelector('.jacu-garment-feel')) card.before(note.content.cloneNode(true));
        const evidence = description.textContent + ' ' + (note ? note.content.textContent : '');
        const traits = [['Soft', /\bsoft(?:ness)?\b/i], ['Warm', /\bwarm(?:th)?\b/i], ['Breathable', /\bbreathab(?:le|ility)\b/i], ['Subtle stretch', /\b(?:subtle|gentle|slight|a little) stretch\b/i]];
        const holder = card.querySelector('[data-fabric-chips]');
        traits.filter(([, test]) => evidence.split(/[.!?;\n]/).some(sentence => test.test(sentence) && !/\b(?:not|no|non|without|less|unconfirmed)\b/i.test(sentence))).forEach(([label]) => {
          const chip = document.createElement('span');
          chip.className = 'jacu-fabric-invitation__chip';
          chip.textContent = label;
          holder.append(chip);
        });
        holder.hidden = !holder.childElementCount;
        card.dataset.cardEnhanced = 'true';
      });
    } catch {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance());
  else enhance();
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
